import {ChatMemberAndUser} from "./ChatMemberAndUser";
import {Participant} from "@twilio/conversations";

export class ChatMemberAndUserManager{

  // private _all = new Array<ChatMemberAndUser>();
  private _mapPerChannelPerIdentity = new Map<string,Map<string,ChatMemberAndUser>>();



   addNewMember(channelSid:string, member:Participant){
    const chatMemberAndUser = new ChatMemberAndUser();
    chatMemberAndUser.member = member;
    member.getUser().then((user)=>{
      chatMemberAndUser.user = user;
    });
    if (!this._mapPerChannelPerIdentity.has(channelSid)){
      this._mapPerChannelPerIdentity.set(channelSid,new Map<string,ChatMemberAndUser>());
    }
    this._mapPerChannelPerIdentity.get(channelSid).set(member.identity,chatMemberAndUser);
  }

  public getFriendlyNameOf(channelSid:string,identity: string):string{
     if (this._mapPerChannelPerIdentity.has(channelSid)){
       if (this._mapPerChannelPerIdentity.get(channelSid).has(identity)){
          return this._mapPerChannelPerIdentity.get(channelSid).get(identity).user.friendlyName;
       }
     }

     return identity;
  }

  public sortMembers(channelSid:string){
     const res = new Array<ChatMemberAndUser>();

       if (this._mapPerChannelPerIdentity.has(channelSid)){
            res.push(...Array.from(this._mapPerChannelPerIdentity.get(channelSid).values()));
       }
    res.sort((a1,a2)=>{
      let tmp = 0;
      if (a1.user && a2.user){
        if (a1.user.isOnline===true && a2.user.isOnline===false){
          tmp = -1;
        }else if (a1.user.isOnline ===false && a2.user.isOnline===true){
          tmp  = 1;
        }
        if (tmp===0){
          tmp = a1.user.friendlyName.localeCompare(a2.user.friendlyName);
        }
      }
      return tmp;
    });

     return res;


  }
  public removeChannel(channelSid: string){
    this._mapPerChannelPerIdentity.delete(channelSid);
  }

  public removeMember(channelSid:string, member:Participant){
    if (this._mapPerChannelPerIdentity.has(channelSid)){
      if (this._mapPerChannelPerIdentity.get(channelSid).has(member.identity)){
        this._mapPerChannelPerIdentity.get(channelSid).delete(member.identity);
        if (this._mapPerChannelPerIdentity.get(channelSid).size<=0){
          this._mapPerChannelPerIdentity.delete(channelSid);
        }
      }
    }
  }

  public updateMember(channelSid:string, member:Participant){
    if (this._mapPerChannelPerIdentity.has(channelSid)) {
      if (this._mapPerChannelPerIdentity.get(channelSid).has(member.identity)) {
        member.getUser().then((user)=>{
          this._mapPerChannelPerIdentity.get(channelSid).get(member.identity).user = user;
        });
      }
    }
  }

  public memberStartTyping(channelSid:string, member:Participant){
    if (this._mapPerChannelPerIdentity.has(channelSid)) {
      if (this._mapPerChannelPerIdentity.get(channelSid).has(member.identity)) {
        member.getUser().then((user)=>{
          this._mapPerChannelPerIdentity.get(channelSid).get(member.identity).typing = true;
        });
      }
    }
  }

  public memberEndTyping(channelSid:string, member:Participant){
    if (this._mapPerChannelPerIdentity.has(channelSid)) {
      if (this._mapPerChannelPerIdentity.get(channelSid).has(member.identity)) {
        member.getUser().then((user)=>{
          this._mapPerChannelPerIdentity.get(channelSid).get(member.identity).typing = false;
        });
      }
    }
  }


}
